import React from 'react';
import { PaperclipIcon } from '@phosphor-icons/react';

interface FileUplaodProps {
    handleFileChange: (event: React.ChangeEvent<HTMLInputElement>, reset: () => void) => void;
    fileTypes: { [key: string]: string[] };
}

export default function FileUpload({ handleFileChange, fileTypes }: FileUplaodProps) {
    const hasAcceptTypes = fileTypes && Object.keys(fileTypes).length > 0;
    const accept = hasAcceptTypes ? Object.values(fileTypes).flat().join(', ') : '';
    if (!hasAcceptTypes || !accept.trim()) {
        return null;
    }
    return (
        <div className={`h-[56px] min-w-[40px] flex pr-0 justify-center items-center`}>
            <input
                id="file-upload"
                type="file"
                accept={accept}
                multiple
                onChange={e => handleFileChange(e, ()=> {
                    const fileInput = document.querySelector('#file-upload') as HTMLInputElement;
                    if (fileInput) {
                        fileInput.value = '';
                    }
                })}
                style={{ display: 'none' }}
            />

            <label
                htmlFor="file-upload"
                className={`text-chatInput-inlineButtonColor hover:text-chatInput-inlineButtonColor-hover  border-none rounded-s bg-transparent cursor-pointer duration-300 `}
            >
                <PaperclipIcon size={24} color="currentColor" />
            </label>
        </div>
    );
}
